import * as React from "react";
import { Dropdown } from "semantic-ui-react";

// Turns the entire clickable area of a dropdown item into a link.
// NB use only for links not handled by the redux router (e.g. login/logout).
const DropdownAnchor: React.SFC<{ href: string }> = ({ href, children }) => (
    <Dropdown.Item>
        <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
    </Dropdown.Item>
);

export { DropdownAnchor };
